class HovEditorialHeader {
  constructor() {
    this.header = document.querySelector('#header-group');
    if (!this.header) return;
    this.update = this.update.bind(this);
    this.update();
    window.addEventListener('scroll', this.update, { passive: true });
  }

  update() {
    this.header.classList.toggle('hov-header--scrolled', window.scrollY > 20);
  }
}

class HovEditorialReveal extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    if (
      document.documentElement.dataset.hovMotion === 'off' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      this.dataset.visible = 'true';
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.visible = 'true';
        this.observer.disconnect();
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

class HovFooterAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.mobileQuery = window.matchMedia('(max-width: 899px)');
    this.buttons = [...this.querySelectorAll('[data-hov-footer-trigger]')];
    this.buttons.forEach((button) => button.addEventListener('click', this.onToggle));
    this.mobileQuery.addEventListener?.('change', this.onViewportChange);
    this.onViewportChange();
  }

  disconnectedCallback() {
    this.buttons?.forEach((button) => button.removeEventListener('click', this.onToggle));
    this.mobileQuery?.removeEventListener?.('change', this.onViewportChange);
  }

  onToggle = (event) => {
    if (!this.mobileQuery.matches) return;
    const button = event.currentTarget;
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    panel.dataset.open = String(!expanded);
  };

  onViewportChange = () => {
    this.buttons.forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = !this.mobileQuery.matches;
      button.setAttribute('aria-expanded', String(expanded));
      if (panel) panel.dataset.open = String(expanded);
    });
  };
}

if (!customElements.get('hov-footer-accordion')) {
  customElements.define('hov-footer-accordion', HovFooterAccordion);
}

if (!customElements.get('hov-editorial-reveal')) {
  customElements.define('hov-editorial-reveal', HovEditorialReveal);
}

const initializeHovEditorial = () => {
  document.documentElement.dataset.hovMotion =
    document.documentElement.dataset.hovMotion || 'on';
  if (!window.hovEditorialHeader) window.hovEditorialHeader = new HovEditorialHeader();
};

document.addEventListener('DOMContentLoaded', initializeHovEditorial, { once: true });
document.addEventListener('shopify:section:load', initializeHovEditorial);
